import { FormFieldLayoutOptions } from "./FormFieldLayoutOptions";

enum FormFieldType
{
    Text,
    Email,
    Tel,
    Dropdown,
    Textarea,
    VideoUpload,
    FileUpload,
    MultiFileUploader,
    StaticText,
    Date,
    Signature,
    GraphicalPDF
}

interface FormField {
    FieldId: string;
    SectionId: string;
    Type: FormFieldType;
    TypeName: string;
    Key: string;
    Label: string;
    Placeholder: string;
    LayoutOptions: FormFieldLayoutOptions;
    Required: boolean;
    
}

export { FormField, FormFieldType }
